<template id="regForm">
<section class="registrationColumn">
  <h2 class="mainheading">{{res.regform}}</h2>
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <div class="formHeadings"> <span><img src="images/primarybusiness.png" alt="#"></span>{{res.bizinfo}}</div>
      </div>
      <div class="col-md-10 col-sm-10 col-md-offset-1 col-sm-offset-1 col-xs-10 col-xs-offset-1 flex-box">
        <div class="col-md-12 col-sm-12" id="a_company">
          <div class="inputBlock">
            <label for="">{{res.company_name}}*</label>
            <div v-if="error.company" v-on:click="removeErr($event,'company')" class="erorContent">
              <p><i class="fa fa-exclamation-circle"></i> {{error.company}}</p>
            </div>
            <input type="text" v-on:focus="removeErr($event,'company')" :class="error.company?'form-control errorMessage inputText':'form-control inputText'" :placeholder="res.hints.company_name" v-model="reseller.company">
          </div>
        </div>
        <div class="col-md-12 col-sm-12" id="a_poc">
          <div class="inputBlock">
            <label for="">{{res.contact_person}}*</label>
            <div v-if="error.poc" v-on:click="removeErr($event,'poc')" class="erorContent">
              <p><i class="fa fa-exclamation-circle"></i> {{error.poc}}</p>
            </div>
            <input type="text" v-on:focus="removeErr($event,'poc')" :class="error.poc?'form-control errorMessage inputText':'form-control inputText'" :placeholder="res.hints.contact_person" v-model="reseller.poc">
          </div>
        </div>
        <div class="col-md-12 col-sm-12" id="a_tel">
          <div class="inputBlock">
            <label for="">{{res.contact_phone}}*</label>
            <div v-if="error.tel" v-on:click="removeErr($event,'tel')" class="erorContent">
              <p><i class="fa fa-exclamation-circle"></i> {{error.tel}}</p>
            </div>
            <input type="text" v-on:focus="removeErr($event,'tel')" :class="error.tel?'form-control errorMessage inputText':'form-control inputText'" :placeholder="res.hints.contact_phone" v-model="reseller.tel">
          </div>
        </div>
        <div class="col-md-12 col-sm-12" id="a_email">
          <div class="inputBlock">
            <label for="">{{res.contact_email}}*</label>
            <div v-if="error.email" v-on:click="removeErr($event,'email')" class="erorContent">
              <p><i class="fa fa-exclamation-circle"></i> {{error.email}}</p>
            </div>
            <input type="email" v-on:focus="removeErr($event,'email')" :class="error.email?'form-control errorMessage inputText':'form-control inputText'" placeholder="" v-model="reseller.email">
          </div>
        </div>
        <div v-if="currencies != null && currencies.length > 1" class="col-md-12 col-sm-12" id="a_currency">
          <div class="inputBlock">
            <label for="">{{res.currency}}</label>
            <select class="form-control inputText" v-model="reseller.currency">
              <option v-for="curr in currencies" :value="curr.value">{{curr.desp}}</option>
            </select>
          </div>
        </div>

        <div class="col-md-6 col-sm-6 uploader" id="a_brimg">

          <div class="inputBlock">
            <label for="">{{res.bizreg}}*</label>
            <div v-if="error.brimg" v-on:click="removeErr($event,'brimg')" class="erorContent">
              <p><i class="fa fa-exclamation-circle"></i> {{error.brimg}}</p>
            </div>
            <div class="browseImage_wrapper">
              <input @change="setBRImg()" ref="brImg" type="file" v-on:click="removeErr($event,'brimg')" :class="error.brimg?'form-control errorMessage inputText':'form-control inputText'" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Browse">
              <div :class="error.brimg?'browseImageCol errorMessage':'browseImageCol'"><img src="images/fileinput.png" alt="#">
                <h6>{{res.upload}}</h6>
              </div>
            </div>
          </div>
          <div class="inputBlock">
            <div id="brimg" class="browseImage" :style="'background-image:url('+getDocImg()+')'">
              <div id="brpreview" class="preview_overlay">
                <img src="images/borwsecamera.png" alt="#">
                <h3>{{res.preview}}</h3>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-sm-6 uploader" id="a_ncimg">
          <div class="inputBlock">
            <label for="">{{res.namecard}}*</label>
            <div v-if="error.ncimg" v-on:click="removeErr($event,'ncimg')" class="erorContent">
              <p><i class="fa fa-exclamation-circle"></i> {{error.ncimg}}</p>
            </div>
            <div class="browseImage_wrapper">
              <!--input type="file" class="form-control inputText" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Browse"-->
              <input @change="setNCImg()" ref="ncImg" type="file" v-on:click="removeErr($event,'ncimg')" :class="error.ncimg?'form-control errorMessage inputText':'form-control inputText'" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Browse">
              <div :class="error.ncimg?'browseImageCol errorMessage':'browseImageCol'"><img src="images/fileinput.png" alt="#">
                <h6>{{res.upload}}</h6>
              </div>
            </div>
          </div>
          <div class="inputBlock">
            <div id="ncimg" class="browseImage" style="background-image:url('images/uploadedimg.jpg')">
              <div id="ncpreview" class="preview_overlay">
                <img src="images/borwsecamera.png" alt="#">
                <h3>{{res.preview}}</h3>
              </div>
            </div>
          </div>
        </div>

        <!--div class="col-md-6 col-sm-6">
          <div class="inputBlock">
            <label for="">Business registration*</label>
            <div v-if="error.brimg" class="erorContent">
              <p><i class="fa fa-exclamation-circle"></i> This is required</p>
            </div>
            <input @change="setBRImg()" ref="brImg" type="file" :class="error.brimg?'form-control errorMessage inputText':'form-control inputText'" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Browse">
            <div class="browseImageCol"><img src="images/fileinput.png" alt="#">
              <h6>Browse</h6>
            </div>
          </div>
          <div class="inputBlock">
            <div class="browseImage">
              <img style="position:absolute;top:0;left:0;vertical-align:middle" id="brimg">
              <img src="images/borwsecamera.png" alt="#">
              <h3>Browse Your Image</h3>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-sm-6">
          <div class="inputBlock">
            <label for="">Name card*</label>
            <div v-if="error.ncimg" class="erorContent">
              <p><i class="fa fa-exclamation-circle"></i> This is required</p>
            </div>
            <input @change="setNCImg()" ref="ncImg" type="file" :class="error.ncimg?'form-control errorMessage inputText':'form-control inputText'" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Browse">
            <div class="browseImageCol"><img src="images/fileinput.png" alt="#">
              <h6>Browse</h6>
            </div>
          </div>
          <div class="inputBlock">
            <div class="uploadedImg"> <img src="images/borwsecamera.png" alt="#"> </div>
          </div>
        </div-->

        <div class="col-md-6 col-sm-6" id="a_biznatid">
          <div class="inputBlock">
            <label for="">{{res.biznature}}*</label>
            <div v-if="error.biznatid" v-on:click="removeErr($event,'biznatid')" class="erorContent">
              <p><i class="fa fa-exclamation-circle"></i> {{error.biznatid}}</p>
            </div>
            <select v-on:focus="removeErr($event,'biznatid')" :class="error.biznatid?'errorMessage inputText':'inputText'" v-model="reseller.biznatid">
              <option v-for="client in clients" :value="client.id" :s="JSON.stringify(client)">{{(client.short!=null)?client.short:getText(client.name)}}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6 col-sm-6" id="a_firstamount">
          <div class="inputBlock">
            <label for="">{{res.firstamt}}*</label>
            <div v-if="error.firstamount" v-on:click="removeErr($event,'firstamount')" class="erorContent">
              <p><i class="fa fa-exclamation-circle"></i> {{error.firstamount}}</p>
            </div>
            <select v-on:focus="removeErr($event,'firstamount')" :class="error.firstamount?'errorMessage inputText':'inputText'" v-model="reseller.firstamount">
              <option v-for="firstamt in firstamts" :value="firstamt.value">{{firstamt.desp}}</option>
            </select>
          </div>
        </div>
        <div class="col-md-12 col-sm-12" id="a_website">
          <div class="inputBlock">
            <label for="">{{res.website}}</label>
            <div v-if="error.website" v-on:click="removeErr($event,'website')" class="erorContent">
              <p><i class="fa fa-exclamation-circle"></i> {{error.website}}</p>
            </div>
            <input type="email" v-on:focus="removeErr($event,'website')" :class="error.website?'form-control errorMessage inputText':'form-control inputText'" placeholder="http://www.johnnjack.com" v-model="reseller.website">
          </div>
        </div>
        <div class="col-md-4 col-sm-6 col-xs-12">
          <div class="socialBlk">
            <p>{{res.fb}}</p>
            <span>{{res.fb_url}}</span> </div>
        </div>
        <div class="col-md-8 col-sm-6 col-xs-12">
          <inputbox v-model="reseller.facebook" :isfloat="false" :res="res" :name="'facebook'"></inputbox>
        </div>
        <div class="col-md-4 col-sm-6 col-xs-12">
          <div class="socialBlk">
            <p>{{res.ig}}</p>
            <span>{{res.ig_url}}</span> </div>
        </div>
        <div class="col-md-8 col-sm-6 col-xs-12">
          <inputbox v-model="reseller.instagram" :isfloat="false" :res="res" :name="'instagram'"></inputbox>
        </div>
        <!--
        <div class="col-md-12 col-sm-12" id="a_facebook">
          <div class="inputBlock">
            <label for="">{{res.fb}}</label>
            <div v-if="error.facebook" v-on:click="removeErr($event,'facebook')" class="erorContent">
              <p><i class="fa fa-exclamation-circle"></i> {{error.facebook}}</p>
            </div>
            <input type="email" v-on:focus="removeErr($event,'facebook')" :class="error.facebook?'form-control errorMessage inputText':'form-control inputText'" placeholder="johnnjack_official" v-model="reseller.facebook">
          </div>
        </div>
        <div class="col-md-12 col-sm-12" id="a_instagram">
          <div class="inputBlock">
            <label for="">{{res.ig}}</label>
            <div v-if="error.instagram" v-on:click="removeErr($event,'instagram')" class="erorContent">
              <p><i class="fa fa-exclamation-circle"></i> {{error.instagram}}</p>
            </div>
            <input type="email" v-on:focus="removeErr($event,'instagram')" :class="error.instagram?'form-control errorMessage inputText':'form-control inputText'" placeholder="johnnjack_official" v-model="reseller.instagram">
          </div>
        </div>
        -->
        <div class="clear"></div>
      </div>
      
      <div class="col-md-12 col-sm-12">
        <div class="formHeadings"> <span><img src="images/truck.png" alt="#"></span>{{res.primaryaddr}}</div>
      </div>
      <div class="col-md-10 col-sm-10 col-md-offset-1 col-sm-offset-1">
        <div class="col-md-12 col-sm-12" id="a_address1">
          <div class="inputBlock">
            <label for="" class="floatLeft">{{res.addr1}}*</label>
            <div v-if="error.address1" v-on:click="removeErr($event,'address1')" class="erorContent erorContentRightAligned"> 
              <p><i class="fa fa-exclamation-circle"></i> {{error.address1}}</p>
            </div>
            <input type="text" v-on:focus="removeErr($event,'address1')" :class="error.address1?'form-control errorMessage inputText floatRight inputRightAligned':'form-control inputText floatRight inputRightAligned'" :placeholder="res.hints.addr1" v-model="reseller.address1">
            <div class="clearFix"></div>
          </div>
          <div class="inputBlock">
            <label for="" class="floatLeft">{{res.addr2}}</label>
            <div v-if="error.address2" v-on:click="removeErr($event,'address2')" class="erorContent erorContentRightAligned"> 
              <p><i class="fa fa-exclamation-circle"></i> {{error.address2}}</p>
            </div>
            <input type="text" v-on:focus="removeErr($event,'address2')" :class="error.address2?'form-control errorMessage inputText floatRight inputRightAligned':'form-control inputText floatRight inputRightAligned'" :placeholder="res.hints.addr2" v-model="reseller.address2">
            <div class="clearFix"></div>
          </div>
          <div class="inputBlock" v-if="res.addr3.length > 0">
            <label for="" class="floatLeft">{{res.addr3}}</label>
            <div v-if="error.address3" v-on:click="removeErr($event,'address3')" class="erorContent erorContentRightAligned"> 
              <p><i class="fa fa-exclamation-circle"></i> {{error.address3}}</p>
            </div>
            <input type="text" v-on:focus="removeErr($event,'address3')" :class="error.address3?'form-control errorMessage inputText floatRight inputRightAligned':'form-control inputText floatRight inputRightAligned'" :placeholder="res.hints.addr3" v-model="reseller.address3">
            <div class="clearFix"></div>
          </div>
          <input type="hidden" v-model="reseller.address3" v-else/>
          <div class="inputBlock">
            <label for="" class="floatLeft">{{res.addr4}}</label>
            <div v-if="error.address4" v-on:click="removeErr($event,'address4')" class="erorContent erorContentRightAligned"> 
              <p><i class="fa fa-exclamation-circle"></i> {{error.address4}}</p>
            </div>
            <input type="text" v-on:focus="removeErr($event,'address4')" :class="error.address4?'form-control errorMessage inputText floatRight inputRightAligned':'form-control inputText floatRight inputRightAligned'" :placeholder="res.hints.addr4" v-model="reseller.address4">
            <div class="clearFix"></div>
          </div>
          
        </div>
        <div class="col-md-12 col-sm-12">
          <div class="inputBlock">
            <label for="">{{res.country}}</label>
            <!--input type="text" class="form-control inputText" placeholder="Hong Kong" v-model="reseller.countryid"-->
            <select :class="error.countryid?'errorMessage form-control inputText':'form-control inputText'" v-model="reseller.countryid">
              <option v-for="country in countries" :value="country.value">{{country.desp}}</option>
            </select>
          </div>
        </div>
        
        <div class="col-md-12 col-sm-12">
          <div class="inputBlock">
            <label for="">{{res.remark}}</label>
            <textarea v-model="reseller.remark" cols="12" rows="12" placeholder="" class="textareaBox"></textarea>
          </div>
        </div>
	<div class="col-md-12 col-sm-12 text-center">
            <!--button class="g-recaptcha form-control submitButton" data-sitekey="6LfX_28UAAAAAKVy8qQjPz_yYFLwrOHeYdX_bwMk" data-callback="alert('test')"> Submit registration</button-->
            <div id="recaptcha" class="g-recaptcha"></div>
            <input v-on:click="chkReg()" type="submit" :class="(submitted?'submitted ':'')+'form-control submitButton'" :value="res.submit">
        </div>
        </div>
    </div>
    
  </div>
</section>
</template>

<script>

import inputbox from './InputBox.vue'
import utils from './Utils.vue'

function readURL(input, func) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function(e) {
      func(e.target.result);
    }
    reader.readAsDataURL(input.files[0]);
  }
}

export default {
  name: 'regForm',
  props:['name', 'clients', 'firstamts', 'countries', 'res', 'common_res', 'currencies'],
  data () {
    return {
      reseller:{"countryid":5, "currency":""},
      submitted:false,
      error:{}
    }
  },
  components: {
    inputbox
  },
  methods: {
    initReCaptcha: function() {
      var self = this;
      setTimeout(function() {
          if(typeof grecaptcha === 'undefined') {
              self.initReCaptcha();
          }
          else {
              grecaptcha.render('recaptcha', {
                  sitekey: '6LfX_28UAAAAAKVy8qQjPz_yYFLwrOHeYdX_bwMk',
                  size: 'invisible',
                  //badge: 'inline',
                  callback: self.doReg
              });
          }
      }, 100);
    },
    validate: function() {
      if (this.submitted) return;
      grecaptcha.execute();
    },
    chk: function(name, regex, errmsg, remove_regex) {
      // mandatory
      // if (0 == mode) {
      if (remove_regex && this.reseller[name] != null) {
        this.reseller[name] = this.reseller[name].replace(remove_regex, '');
      }
      if (regex) {
        var chkval = (this.reseller[name])?this.reseller[name]:'';
        if (!regex.test(chkval)) {
          if (errmsg) this.error[name] = errmsg;
          else this.error[name] = " This is required";
//console.log('false:'+name+":"+chkval);
          return false;
        } else {
          delete this.error[name];
          return true;
        }
      }
      // }
    },
    getText(node) {
      var d = $('<div>'+(node)+'</div>');
      return d.text();
    },
    setNCImg:function() {
      var self = this;
      readURL(this.$refs.ncImg, function(res) {
        //$('#ncimg').attr('src', res);
        $('#ncimg').attr('style', 'background-image: url('+res+');');
        $('#ncpreview').addClass('hide');
        self.reseller['ncimg'] = res;
      });
    },
    setBRImg:function() {
      var self = this;
      readURL(this.$refs.brImg, function(res) {
        //$('#brimg').attr('src', res);
        $('#brimg').attr('style', 'background-image: url('+res+');');
        $('#brpreview').addClass('hide');
        self.reseller['brimg'] = res;
      });
    },
    getDocImg() {
      if (this.res.docimg == null) {
        return 'images/br.jpg';
      }
      return this.res.docimg;
    },
    chkReg:function() {
      console.log(this.reseller);
      var self = this;
      var isok = true;
      var goto = null;
      if (!this.chk('company', /^.{1,}$/, this.res.company_name_err)) {
        isok = false;
        if (!goto) goto = 'company';
      } else if (!this.chk('company', /^.{1,255}$/, this.res.company_name_toolong)) {
        isok = false;
        if (!goto) goto = 'company';
      }
      if (!this.chk('poc', /^.{1,}$/, this.res.contact_person_err)) {
        isok = false;
        if (!goto) goto = 'poc';
      } else if (!this.chk('poc', /^.{1,255}$/, this.res.contact_person_toolong)) {
        isok = false;
        if (!goto) goto = 'poc';
      }
      if (!this.chk('tel', /^.{1,}$/, this.res.contact_phone_err)) {
        isok = false;
        if (!goto) goto = 'tel';
      } else if (!this.chk('tel', /^[0-9]{8,50}$/, this.res.contact_phone_invalid)) {
        isok = false;
        if (!goto) goto = 'tel';
      }
      if (!this.chk('email', /^.{1,}$/, this.res.contact_email_err)) {
        isok = false;
        if (!goto) goto = 'email';
      } else if (!this.chk('email', /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i, this.res.contact_email_invalid)) {
        isok = false;
        if (!goto) goto = 'email';
      }
      if (!this.chk('brimg', /^.{1,}$/, this.res.bizreg_err)) {
        if (!goto) goto = 'brimg';
        isok = false;
      }
      if (!this.chk('ncimg', /^.{1,}$/, this.res.namecard_err)) {
        if (!goto) goto = 'ncimg';
        isok = false;
      }
      if (!this.chk('biznatid', /^.{1,}$/, this.res.biznature_err)) {
        if (!goto) goto = 'biznatid';
        isok = false;
      }
      if (!this.chk('firstamount', /^.{1,}$/, this.res.firstamt_err)) {
        if (!goto) goto = 'firstamount';
        isok = false;
      }
      if (!this.chk('website', /^$|^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,63}(:[0-9]{1,5})?(\/.*)?$/, this.res.website_err)) {
        isok = false;
        if (!goto) goto = 'website';
      } else if (!this.chk('website', /^.{0,255}$/, this.res.website_toolong)) {
        isok = false;
        if (!goto) goto = 'website';
      }
      if (!this.chk('facebook', /^$|^[A-Za-z0-9_\-\.]+$/, this.res.socialname_err, /https?:\/\/(www\.)?facebook\.com\//g)) {
        isok = false;
        this.$root.$emit('facebook', {"error":this.res.socialname_err});
        if (!goto) goto = 'facebook';
      } else if (!this.chk('facebook', /^.{0,100}$/, this.res.socialname_toolong, /https?:\/\/(www\.)?facebook\.com\//g)) {
        isok = false;
        this.$root.$emit('facebook', {"error":this.res.socialname_toolong});
        if (!goto) goto = 'facebook';
      }
      if (!this.chk('instagram', /^$|^[A-Za-z0-9_\-\.]+$/, this.res.socialname_err, /https?:\/\/(www\.)?instagram\.com\//g)) {
        isok = false;
        this.$root.$emit('instagram', {"error":this.res.socialname_err});
        if (!goto) goto = 'instagram';
      } else if (!this.chk('instagram', /^.{0,100}$/, this.res.socialname_toolong, /https?:\/\/(www\.)?instagram\.com\//g)) {
        isok = false;
        this.$root.$emit('instagram', {"error":this.res.socialname_toolong});
        if (!goto) goto = 'instagram';
      }
      if (!this.chk('address1', /^.{1,}$/, this.res.addr1_err)) {
        if (!goto) goto = 'address1';
        isok = false;
      } else if (!this.chk('address1', /^.{1,255}$/, this.res.addr1_toolong)) {
        isok = false;
        if (!goto) goto = 'address1';
      }
      if (!this.chk('address2', /^.{0,255}$/, this.res.addr2_toolong)) {
        isok = false;
        if (!goto) goto = 'address2';
      }
      if (!this.chk('address3', /^.{0,255}$/, this.res.addr3_toolong)) {
        isok = false;
        if (!goto) goto = 'address3';
      }
      if (!this.chk('address4', /^.{0,255}$/, this.res.addr4_toolong)) {
        isok = false;
        if (!goto) goto = 'address4';
      }
      if (isok) {
        this.validate();
      } else {
        if (goto) {
          $("#a_"+goto)[0].scrollIntoView();
          goto = null;
        }
        var fd = utils.saveJSONToForm(this.reseller);
        //self.$emit('iposevent', 'doregister', this.reseller);
      }
      this.$forceUpdate();
    },
    doReg:function(response) {
      var self = this;
      if (self.submitted) return;
      self.submitted = true;
      if (response != null) {
        this.reseller['g-recaptcha-response'] = response;
      }
      if (1==1) {
        this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':this.common_res.message.waiting});
        utils.saveData({
            url: utils.getServerPath()+'/reseller/reg.is',
            mode: 'insert',
            repos: 'db',
            value: utils.saveJSONToForm(this.reseller),
            name: 'reg.reseller'
          }, function(success, data) {
            self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
            if (success) {
              if (data.success != 1) {
                Object.keys(data.form).forEach(function(key) {
                  if (data.form[key] != 0) {
                    self.error[key] = " Invalid value";
                    $("#a_"+key)[0].scrollIntoView();
                  }
                });
                if (data.success == -2) {
                  $("#a_email")[0].scrollIntoView();
                  self.error['email'] = self.res.email_used;
                } else if (data.success == -3) {
                  $("#a_email")[0].scrollIntoView();
                  self.error['email'] = self.res.email_used;
                } else if (data.success == -4) {
                  $("#a_email")[0].scrollIntoView();
                  self.error['email'] = self.res.email_used;
                }
                self.$forceUpdate();
              } else {
                self.$emit('iposevent', 'doregister', self.reseller);
                return;
              }
            }
            self.submitted = false;
            grecaptcha.reset();
        });
      } else {
        grecaptcha.reset();
      }
      this.$forceUpdate();
    },
    removeErr: function(evt, name) {
      delete this.error[name];
      this.$forceUpdate();
    }
  },
  mounted: function() {
    this.initReCaptcha();
    if (this.countries != null) {
      this.reseller.countryid = this.countries[0].value;
    }
    //this.currencies.push({"name":"GBP", "value":""});
    //this.currencies.push({"name":"EUR", "value":"EUR"});
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RegForm.vue